import { SvgIcon, SvgIconProps } from '@material-ui/core'

export default function EnabledIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <g transform="translate(3 4) scale(1.3)">
                <circle cx="7" cy="6.375" r="2.5" fill="currentColor" stroke="currentColor" />
                <path
                    d="M12.1962 9.5C12.7228 8.58788 13 7.55322 13 6.5C13 5.44678 12.7228 4.41212 12.1962 3.5C11.6695 2.58788 10.9121 1.83046 10 1.30385C9.08788 0.777237 8.05322 0.5 7 0.5C5.94678 0.5 4.91211 0.777238 4 1.30385C3.08788 1.83046 2.33046 2.58789 1.80385 3.5C1.27724 4.41212 1 5.44678 1 6.5C1 7.55322 1.27724 8.58789 1.80385 9.5"
                    stroke="currentColor"
                    strokeLinecap="round"
                    fill="none"
                />
            </g>
        </SvgIcon>
    )
}
